// src/components/canvaspuzzle/components/pieces/DraggingPiece.js
import React from 'react'; // Добавим импорт React
import useStore from '../../../../store';
import PuzzlePiece from './PuzzlePiece'; // Импортируем обновленный PuzzlePiece

const DraggingPiece = () => {
  
  // Подписываемся на нужные части для ререндера
  const pointerPosition = useStore(state => state.pointerPosition);
  useStore(state => state.puzzleRender);
  useStore(state => state.puzzleRedraw);

  const store = useStore.getState();
  const { ref } = store;
  const { puzzle } = ref;
  const { config, state, boardTransform } = puzzle;


  const draggingPiece = state.draggingPiece || state.finishingRotationPieceId;

  // Если нет перетаскиваемого пазла, ничего не рендерим
  if (!draggingPiece) {
    return null;
  }

  const distance = Math.sqrt(
    Math.pow(pointerPosition.x - draggingPiece.dragStartPos.x, 2) +
    Math.pow(pointerPosition.y - draggingPiece.dragStartPos.y, 2)
  );

  if (distance > 5) {
    draggingPiece.moved = true;
  }

  if (
    draggingPiece.pointerType === 'touch' 
    && config.user.touchDragOffsetY
    && draggingPiece.moved
  ) {
    draggingPiece.touchOffsetY = -config.user.touchDragOffsetY;
  }


  const piece = puzzle.state.pieces[draggingPiece.pieceId];

  const { scaledTotalDimensions, scaledTabExtensions } = puzzle.methods.calculateOnePiece(draggingPiece.pieceId);

  // Вычисляем финальные координаты для позиционирования
  const positionX = 
  pointerPosition.x 
  - scaledTabExtensions.width
  - draggingPiece.offset.x 
  + 0;

  const positionY = 
  pointerPosition.y 
  - scaledTabExtensions.height
  - draggingPiece.offset.y + draggingPiece.touchOffsetY
  - 1;

  // Стили для внешнего div-контейнера, который будет позиционироваться
  const containerStyle = {
    width: scaledTotalDimensions.width,
    height: scaledTotalDimensions.height,
    position: 'fixed',
    left: 0,
    top: 0,
    zIndex: 1000, 
    touchAction: 'none', 
    overflow: 'visible', 
    transform: `translate(${positionX}px, ${positionY}px) rotate(${piece.rotation}deg)`,
    pointerEvents: 'none', 
    transition: state.finishingRotationPieceId ? 'transform 0.05s ease' : 'none',
  };
  
  return (
    // Контейнер с рассчитанными стилями позиционирования
    <div style={containerStyle}>
      <PuzzlePiece pieceId={draggingPiece.pieceId} overrideStyle={{
        transform: 'none',
      }} />
    </div>
  );
};

export default DraggingPiece;